import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/**
 * Custom hook to access group logos from Redux store
 * @returns {Array<string>} Array of logo paths
 */
export const useGroupLogos = (showLabel = false) => {
	const { logoPaths, franchiseList } = useSelector((state) => ({
		logoPaths: state.groupLogos?.logoPaths || [],
		franchiseList: state.franchiseList?.franchiseList || []
	}));

	return useMemo(() => {
		if (!franchiseList.length) return [];

		return franchiseList.map((franchiseName) => {
			// Convert spaces to hyphens for URL matching
			const franchiseNameForUrl = franchiseName
				.toLowerCase()
				.replace(/\s+/g, '-');

			// Find matching logo path
			const matchingLogo = logoPaths.find((path) =>
				path.toLowerCase().includes(`/${franchiseNameForUrl}/`)
			);

			return {
				brand: {
					name: franchiseName,
					brandLogoImgUrl: matchingLogo || '',
					href: `/all-inventory/index.htm?make=${franchiseNameForUrl}`,
					showLabel: !!showLabel
				}
			};
		});
	}, [logoPaths, franchiseList, showLabel]);
};
